module.exports = __webpack_public_path__ + "static/media/Colette Single 2-Drawer Bed Base 90x200_Teal.b8085df7.png";